'use client';

import { useEffect, useRef } from 'react';
import { useChat } from '../context/ChatContext';
import ChatMessageItem from './ChatMessageItem';
import styles from '../styles/ChatMessages.module.css';

export default function ChatMessages() {
  const { messages } = useChat();
  const bottomRef = useRef<HTMLDivElement | null>(null);

  // Auto scroll to bottom when messages change
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (!messages.length) return null;

  return (
    <div className={styles.messagesContainer}>
      {messages.map((msg, index) => (
        <ChatMessageItem key={index} message={msg} />
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
